import React, { useContext } from 'react';
import EditListItem from './Product/EditListItem';
import NotFoundListItem from './Product/NotFoundListItem';
import { TranslationContext, SettingsContext } from "./Context";

function CartDetail(props) {

    const translation = useContext(TranslationContext);
    const settings = useContext(SettingsContext);

    return (

        <div className="container u-mtop50">
            <div className="row">
                <div className="col-xs-12">
                    <h1 className="u-textBold38 text-center u-mtop50 u-mbottom30">{translation["TecAlliencePartSearch.CartSummary.ReviewYourCart"]}</h1>
                </div>
           </div>
            <div className="row">
                <div className="col-xs-12">
                    <ul className="vehicleProductListComponent-list vehicleProductListComponent-list--cart">
                        {props.items.map(i => {
                            const article = props.articles.find(a => a.articleNumber === i.articleNumber);

                            if (article) {
                                return <EditListItem key={i.articleNumber} article={article} quantity={i.quantity} onItemChange={props.onItemChange} onItemRemove={props.onItemRemove} />;
                            }

                            return <NotFoundListItem key={i.articleNumber} item={i} article={article} quantity={i.quantity} />;
                        })}
                    </ul>
                </div>
            </div>
            <div className="row u-mtop50">
                <div className="col-sm-6 u-mbottom20">
                    <a href={settings.continueShoppingUrl} className="btn btn-primary u-xsBlock">{translation["TecAlliencePartSearch.CartSummary.KeepShopping"]}</a>
                </div>

                <div className="col-sm-6 text-right">
                    <p className="text-muted small">{translation["TecAlliencePartSearch.CartSummary.CustomerSpecificPricesWillBeAppliedLater"]}</p>
                </div>
            </div>
        </div>

    );

}

export default CartDetail;